import getApiClient from '@/plugins/api-client'

export default {
  loadTestimonials () {
    const api = getApiClient(this.$store)

    api.get('testimonials')
      .then(result => {
        this.testimonials = result.data['hydra:member']
      })
      .catch(error => {
        this.error = error
      })
  },

  saveSorting () {
    const api = getApiClient(this.$store)

    const data = {}

    this.testimonials.forEach((testimonial, index) => {
        data[testimonial['@id']] = index
    })

    api.put('testimonial/sort', data)
      .then(() => {
        this.orderChanged = false
        this.$store.commit('app/raiseSuccess', 'Ordem atualizada')
      })
      .catch(error => {
        this.error = error
        this.$store.commit('app/raiseError', 'Erro ao salvar ordenação. Tente novamente')
      })
  },

  askDelete (testimonialId) {
    this.showDeleteDialog = true
    this.deletingId = testimonialId
  },

  cancelDelete () {
    this.showDeleteDialog = false
    this.deletingId = null
  },

  confirmDelete () {
    if (!this.deletingId) {
      return
    }

    const api = getApiClient(this.$store)

    api.delete(this.deletingId)
      .then(result => {
        if (result.status === 204) {
          this.$store.commit('app/raiseSuccess', 'Depoimento excluído')
          this.loadTestimonials()
        }
      })
      .catch(() => {
        this.$store.commit('app/raiseError', 'Erro ao excluir depoimento')
        this.loadTestimonials()
      })
      .finally(() => {
        this.cancelDelete()
      })
  },
}
